module.exports = fox._r("fonts/infinity-icon-set.woff", __webpack_public_path__ + "fonts/3bmfVII.woff");


//////////////////
// WEBPACK FOOTER
// ./fonts/infinity-icon-set.woff
// module id = 964
// module chunks = 4